import Lottie from 'lottie-react'
import mailAnimation from '../../assets/animations/Mail V3.json'

interface MailIconProps {
  size?: number
  className?: string
}

const MailIcon = ({ size = 24, className = '' }: MailIconProps) => {
  return (
    <div style={{ width: size, height: size, aspectRatio: '1 / 1', contain: 'layout' }} className={className}>
      <Lottie
        animationData={mailAnimation}
        loop={true}
        autoplay={true}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  )
}

export default MailIcon